import _ from 'lodash';
import HelperAvailability from "utils/helper/HelperAvailability";
import { dataConstants } from "services/redux/data/constants";
import ObjectClass from "utils/objects/object";
import { bookingConstants } from "utils/constants/booking-constants";
import ObjectScan from "utils/objects/scan";
import store from "services/redux/store";
import { constantsActive } from 'utils/constants/constants'
import { buildingConstants } from 'utils/constants/building-constants'

export default class ObjectBuilding {
	
	static defaults = {
		kind: buildingConstants.KIND_OFFICE,
		available_for: HelperAvailability.AVAILABLE_FOR_EVERYONE,
		aed: constantsActive.NO,
		active: constantsActive.YES,
	}
	
	/**
	 *
	 * @param value
	 */
	static log = ( value ) => {
		console.prefix( 'ObjectBuilding', value );
	}
	
	/**
	 *
	 * @param objects
	 * @returns {*[]}
	 */
	static get = ( objects ) => {
		return ObjectClass.get( objects, dataConstants.BUILDINGS );
	}
	
	/**
	 *
	 * @param guid
	 * @returns {unknown}
	 */
	static first = ( guid ) => {
		return _.first(
			this.get([ { guid: guid } ])
		);
	}
	
	/**
	 *
	 * @param objects
	 * @returns {unknown[]}
	 */
	static filter = ( objects ) => {
		return _.filter( ObjectClass.filterActive( objects ), object => {
			return HelperAvailability.isAvailable( bookingConstants.BUILDING, object );
		})
	}
	
	/**
	 * Sort teh bookings by start
	 * @param objects
	 * @returns {objects[]}
	 */
	static order = ( objects ) => {
		return _.orderBy( objects, 'position', 'asc' )
	}
	
	/**
	 * Remove inactive bookings and sort by start
	 * @param objects
	 * @returns {objects[]}
	 */
	static filterAndOrder = ( objects ) => {
		return this.order( this.filter( objects ) );
	}
	
	/**
	 *
	 * @param employee
	 */
	static getAllFromEmployee = ( employee ) => {
		// Init the variable
		const buildings = {};
		
		if( _.isEmpty( employee ) ) {
			return buildings;
		}
		
		// Get from the state
		const _buildings = store.getState().data[ dataConstants.BUILDINGS ];
		
		// Bookings
		_.forEach( employee?.bookings, booking => {
			const buildingGuid = _.get( booking, ['building', 'guid'], null );
			
			if( buildingGuid !== null && !_.has( buildings, buildingGuid ) ) {
				const building = _.get( _buildings, buildingGuid, {} );
				
				if( !_.isEmpty( building ) ) {
					buildings[ building.guid ] = {
						...building,
						present: false
					};
				}
			}
		});
		
		// Scans
		_.forEach( employee.scans, scan => {
			const buildingGuid = _.get( scan, ['building', 'guid'], null );
			
			if( buildingGuid !== null && _.has( buildings, buildingGuid ) ) {
				const building = _.get( buildings, buildingGuid, {} );
				
				if( !building.present ) {
					building.present = ObjectScan.isPresent( scan );
				}
			}
		});
		
		return buildings;
	}
	
	static hasFloors = ( building ) => {
		const floors = _.get( building, 'floors', [] );
		
		return _.size( ObjectClass.filterActive( floors ) ) > 0;
	}
}
